import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

import SectionContactUs from "../HomePage/Sections/SectionContactUs";
// core components
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Parallax from "components/Parallax/Parallax.js";

import styles from "assets/jss/material-kit-react/views/workPage.js";

import laptop from "assets/img/work/egs/laptop.png";
import iphone1 from "assets/img/work/egs/iPhone-X1.png";
import iphone2 from "assets/img/work/egs/iPhone-X2.png";
import iphone3 from "assets/img/work/egs/iPhone-X3.png";
import questions from "assets/img/work/egs/questions.png";
import longScreens from "assets/img/work/egs/longscreens-EGS.png";
import headerImg from "assets/img/work/egs/header.png";


const useStyles = makeStyles(styles);

export default function ProfilePage(props) {
  const classes = useStyles();
  const mainClasses = classNames({
    [classes.main]: true,
    [classes.egs]: true
  });
  const { ...rest } = props;
  
  return (
    <div>
      <Header
        color="white"
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 400,
          color: "white"
        }}
        {...rest}
      />
      <Parallax className="egs" small image={headerImg}>
        <div className="portfolio-client-name egs">
          <span>E</span>
          <span>G</span>
          <span>S</span>
        </div>
        <div className="portfolio-title egs">
          GERDHELP
        </div>
      </Parallax>
      <div className={mainClasses}>
        <div>
          <div className={classes.container}>
            <h1 className={classes.title}>Gerdhelp project</h1>
            <GridContainer justify="flex-start">
              <GridItem xs={12} sm={12} md={8}>
              <p>The goal: get people off PPIs. Now, several months after the launch of the direct-to-consumer (DTC) website, the regulatory spotlight is trained on misuse of PPIs and the consequences. The TIF® procedure is a perfect example of device innovation freeing patients from long-term disease management with pharmaceuticals– our sweet spot.</p>
              </GridItem>
            </GridContainer>
          </div>
          <div className={classes.container}>
            <GridContainer justify="flex-start">
              <GridItem xs={12} sm={12} md={12}>
                <img alt="" src={laptop} />
              </GridItem>
            </GridContainer>
          </div>

          <div className="vertical-holder cta top">
            <div className={classes.container} style={{marginTop:'100px'}}>
              <GridContainer justify="center" className="flex-center">
                <div className="item questions"><img alt="" src={questions} /></div>
              </GridContainer>
            </div>
          

            <div className="vertical-holder story top">
              <div className={classes.container} style={{marginTop:'100px'}}>
                <GridContainer justify="center" className="flex-center">
                  <div className="item longscreens"><img alt="" src={longScreens} /></div>
                </GridContainer>
              </div>
            </div>
          </div>

          <div className={classes.container} style={{marginTop:'100px'}}>
            <GridContainer justify="center" className="flex-center">
              <div className="item iphone"><img alt="" src={iphone1} /></div>
              <div className="item iphone"><img alt="" src={iphone2} /></div>
              <div className="item iphone"><img alt="" src={iphone3} /></div>
            </GridContainer>
          </div>
          
          <div className={classes.container}>
            <SectionContactUs />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
